import React from 'react'

const ContactInfoContext = React.createContext({
  contactInfo: {},
  setContactInfo: () => {},
})

export default ContactInfoContext
